import { Environment } from '@shared/interfaces/environment';
import { RoutesPath } from '@shared/enums/routes-path';
import { ServiceDetailRoutesPath } from '@vincertif/pages/services/enums/service-detail-routes-path';
import { ArticleDetailRoutesPath } from '@vincertif/pages/articles/enums/article-detail-routes-path';
import { GlobalRoutesPath } from '@shared/enums/global-routes-path';

export const environment: Environment = {
  production: true,
  langs: {
    fr: {
      host: 'vincertif.com',
      langs: ['fr'],
      defaultLang: 'fr',
      countryCode: ['fr'],
      plate: {
        code: 'f',
        placeholder: 'AB-123-CD',
      },
      api: {
        url: 'https://api.vincertif.com',
      },
      google: {
        maps: {
          apiKey: 'AIzaSyD3x-BEC9uo0V3zMtXRg1vC42iRJubvM8Q',
        },
      },
      sentry: {
        dsn: 'https://062f0856b019d0c7a2dbc57edf5758ef@o4508637161783296.ingest.de.sentry.io/4508698635862096',
      },
      config: {
        name: 'Vincertif',
        test: false,
        subscription: {
          name: 'Vincertif Pro',
          prices: {
            fixed: 0.99,
            subscription: 49.99,
          },
          credit: 15,
        },
        advices: [
          {
            rate: 4.7,
            vote: 2254,
          },
        ],
        company: {
          rcs: '207787211',
          vat: 'BG207787211',
          address: 'Jawaharlal Neru n.28, Silver Center, fl.2, office 64. 1324 Sofia, Bulgaria',
          name: 'INOVATECH SOLUTIONS LTD',
        },
        partners: [
          {
            name: 'techcars',
            logo: '/assets/img/partners/partner-1.png',
          },
          {
            name: 'turbauto',
            logo: '/assets/img/partners/partner-2.png',
          },
          {
            name: 'roadup',
            logo: '/assets/img/partners/partner-3.png',
          },
          {
            name: 'autogo',
            logo: '/assets/img/partners/partner-4.png',
          },
        ],
        payment: {
          logo: '/assets/favicon.png',
        },
      },
      routes: {
        [RoutesPath.SIGN_IN]: 'auth-connexion',
        [RoutesPath.SIGN_UP]: 'auth-inscription',
        [RoutesPath.UNSUBSCRIBE]: 'quitter',
        [RoutesPath.FORGOT_PASSWORD]: 'mot-de-passe-perdu',
        [RoutesPath.RESET_PASSWORD]: 'reset-password',
        [RoutesPath.CONTACT]: 'contactez-nous',
        [RoutesPath.SERVICES]: 'que-faisons-nous',
        [RoutesPath.ARTICLES]: 'actualites',
        [RoutesPath.LANDINGS]: 'landings/car-history',
        [RoutesPath.DASHBOARD]: 'mon-espace',
        [RoutesPath.NOT_FOUND]: 'erreur',
        [RoutesPath.ABOUT]: 'qui-sommes-nous',
        [RoutesPath.PREVIEW]: 'exemple-apercu',
        [RoutesPath.PAYMENT_INTENT]: 'transaction-intention',
        [RoutesPath.PAYMENT_VALIDATION]: 'transaction-validation',
        [RoutesPath.LOADING]: 'etat-chargement',
        [RoutesPath.LOADING_PREVIEW]: 'chargement-exemple',
        [RoutesPath.PRICING]: 'details-tarifs',
        [RoutesPath.TESTIMONIALS]: 'retours',
        [RoutesPath.SERVICE]: 'informations-service',
        [RoutesPath.SSO]: 'instantlogin',
        [RoutesPath.CAR_NOT_FOUND]: 'auto-introuvable',
        [RoutesPath.VIN]: '',
        [RoutesPath.COMPARE]: '',
        [RoutesPath.PARTNERS]: '',
        [RoutesPath.GLOSSARY]: '',
        [RoutesPath.COMPANY]: '',
        [RoutesPath.AFFILIATE]: '',
        [RoutesPath.LEASING]: '',
        [RoutesPath.INSURANCE]: '',
        [RoutesPath.CAREERS]: '',
        [RoutesPath.GUIDE]: '',
        [RoutesPath.PRESS]: '',
      },
      globalRoutes: {
        [GlobalRoutesPath.LEGAL_NOTICE]: 'mentions-legales',
        [GlobalRoutesPath.PRIVACY_POLICY]: 'politique-de-confidentialite',
        [GlobalRoutesPath.REFUND_POLICY]: 'politique-de-remboursement',
        [GlobalRoutesPath.TERMS_AND_CONDITIONS]: 'conditions-generales',
        [GlobalRoutesPath.TERMS_OF_SALES]: 'conditions-generales-de-vente',
        [GlobalRoutesPath.FREQUENTLY_ASKED_QUESTIONS]: 'faq',
      },
      serviceRoutes: {
        [ServiceDetailRoutesPath.VEHICLE_VALUATION]: 'vehicle-valuation',
        [ServiceDetailRoutesPath.VEHICLE_SALE]: 'vehicle-sale',
        [ServiceDetailRoutesPath.VEHICLE_PURCHASE]: 'vehicle-purchase',
        [ServiceDetailRoutesPath.THEFT_DECLARATION]: 'theft-declaration',
      },
      articleRoutes: {
        [ArticleDetailRoutesPath.THE_DANGERS_OF_MILEAGE_FRAUD]: 'the-dangers-of-mileage-fraud',
        [ArticleDetailRoutesPath.PRACTICAL_GUIDE_TO_SUCCESSFULLY_SELL_YOUR_USED_CAR]:
          'practical-guide-to-successfully-sell-your-used-car',
        [ArticleDetailRoutesPath.ESSENTIAL_STEPS_TO_TAKE_BEFORE_BUYING_A_USED_CAR]:
          'essential-steps-to-take-before-buying-a-used-car',
        [ArticleDetailRoutesPath.HOW_TO_PROPERLY_EVALUATE_YOUR_CAR_VALUE]: 'how-to-properly-evaluate-your-car-value',
        [ArticleDetailRoutesPath.THE_ADVANTAGES_OF_CHECKING_YOUR_CAR_HISTORY_BEFORE_PURCHASE]:
          'the-advantages-of-checking-your-car-history-before-purchase',
        [ArticleDetailRoutesPath.WARNING_SIGNS_OF_A_POSSIBLE_MECHANICAL_ISSUE]:
          'warning-signs-of-a-possible-mechanical-issue',
      },
      automation: {
        addUserToEmailing: 'jc7mwvu5bbqud68k7f79pd1q19ssv58r',
        removeUserToEmailing: 'hctczp5c4vvgeuq14l7c9w9iqjgj0k9w',
      },
    },
  },
};
